import { Fragment, h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../services/interfaces';

import {
  MatchCta,
  MatchFouls,
  MatchInfo,
  MatchLivePenalties,
  MatchPostPenaltiesScore,
  MatchRelated,
  MatchScore,
  MatchStatusInfo,
  MatchTeam,
  TeamRedCards,
} from './components';
import { printCta, setCssVariant } from './helpers/match-unit.helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
  onCtaClick: (e: MouseEvent) => void;
};

const MatchUnitHorizontal = ({ state, onCtaClick }: Props, children: HTMLDivElement) => {
  const size = state.size;
  const isCtaSlotEmpty = state.isCtaSlotEmpty;
  const hideCta = state.hideCta;
  const showFouls = state.showFouls;
  const match = state.matchData;
  const cssVariant = setCssVariant(size);

  const showCta = !hideCta && isCtaSlotEmpty && printCta(match);

  return (
    <Fragment>
      {/* TOP */}
      <div class="pk-match__top" part="match-top">
        {/* INFO */}
        <MatchInfo state={state} />
        {/* RELATED */}
        <MatchRelated state={state} />
        {/* FOULS (Futsall ONLY)  */}
        {showFouls && <MatchFouls state={state} />}
      </div>
      {/* BASE */}
      <div class="pk-match__base" part="match-base">
        {/* HOME Team */}
        <MatchTeam state={state} />
        {/* HOME Team - red cards */}
        <TeamRedCards state={state} />
        {/* SCORE */}
        <MatchScore state={state} />
        {/* AWAY Team - red cards */}
        <TeamRedCards state={state} isAwayTeam={true} />
        {/* AWAY Team */}
        <MatchTeam state={state} isAwayTeam={true} />
      </div>
      <div class="pk-match__bottom" part="match-bottom">
        {/* PENALTIES RESULTS */}
        <MatchPostPenaltiesScore state={state} />
        <div class={{ 'pk-match__status': true, ...cssVariant }} part="match-status">
          {/* STATUS */}
          <MatchStatusInfo state={state} />
        </div>
        {/* LIVE PENALTIES */}
        <MatchLivePenalties state={state} />

        {showCta && <MatchCta state={state} onCtaClick={onCtaClick} />}
        {/* ADDITIONAL INFORMATION OR CALL TO ACTION */}
        {children}
      </div>
    </Fragment>
  );
};

export { MatchUnitHorizontal };
